// extracted by mini-css-extract-plugin
export var animationContainer = "_fs-0";
export var asteriskIcon = "_fs-8";
export var conversationLeftSection = "_fs-4";
export var conversationListItem = "_fs-3";
export var conversationMiddleSection = "_fs-5";
export var conversationRightSection = "_fs-6";
export var detailsContent = "_fs-1";
export var listContainer = "_fs-7";
export var modalContent = "_fs-2";